// extracted by mini-css-extract-plugin
export default {"panel":"NsKyYBPJFpEAo3SuWKSC"};